import React from 'react';
import { connect } from 'react-redux';
import { isEqual, get } from 'lodash';
import { withRouter } from 'react-router';
import moment from 'moment';

import Spinner from '../../common/Spinner';
import { statsActions } from '../../../data/actions/stats';
import { milestonesActions } from '../../../data/actions/milestones';
import Modal from '../../common/Modal';

class DataProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataReady: false,
            earlyReleaseEntries: [],
            earlyReleaseShown: false
        }
    }

    
    componentDidMount() {
        const { filtered } = this.props;
        Promise.all([
         this.props.getEntitiesMetadata(filtered),
         this.props.getEntitiesMilestones(filtered)
         ]).then((data)=>{
            const earlyReleases = this.checkEarlyReleases();
            this.setState({
                dataReady: true,
                earlyReleaseEntries: earlyReleases,
                earlyReleaseShown: false
            }); 
         });
    }
        
    componentWillReceiveProps(nextProps){
        if(nextProps.filtered && !isEqual(nextProps.filtered, this.props.filtered)){
            const { filtered } = nextProps;
            this.setState({dataReady: false}, ()=>{
                Promise.all([
                this.props.getEntitiesMetadata(filtered),
                this.props.getEntitiesMilestones(filtered)
                 ]).then((data)=>{                     
                     const earlyReleases = this.checkEarlyReleases();
                     this.setState({
                         dataReady: true,
                         earlyReleaseEntries: earlyReleases,
                         earlyReleaseShown: false
                     })
                 });
            })
        }
    }
    
    checkFirstDays(){
        const { firstDays } = this.props.filter.global;
        const { filtered } = this.props;
        if(firstDays > 0)
            return (filtered.products === undefined && filtered.tracks === undefined);
        else
            return false;
    }
    
    checkEarlyReleases(){
        const { firstDays } = this.props.filter.global;
        if(!firstDays)
            return [];
        
        let earlyReleases = [];    
        const { stats, user } = this.props;
        const firstDataDate = moment(get(user, 'user.first_data_date'));
        const filtered = get(stats, 'multiMetadata', []);
        for(let entity of filtered.filter(e=>(e.entity == 'products' || e.entity == 'tracks'))) {
            if(moment(entity.releaseDate).isBefore(firstDataDate))
                earlyReleases.push(entity);
        }
        return earlyReleases;
    }
    
    componentWillUnmount() {
        this.props.resetMinDate();
    }
    
    
    
    render (){  
//        const { multiMetadata = [], multiMetadataLoading } = this.props.stats;
//        const { items: milestones = [], loading: milestonesLoading } = this.props.milestones.entities.mixed;
        
        //const dataReady = (multiMetadataLoading === false && milestonesLoading === false);
        const { dataReady, earlyReleaseEntries, earlyReleaseShown } = this.state;
        const showReleaseModal = !earlyReleaseShown && Array.isArray(earlyReleaseEntries) && earlyReleaseEntries.length > 0;
        const firstDaysWarning = this.checkFirstDays();
        
        return (dataReady && !firstDaysWarning) ? 
            <React.Fragment>
                {this.props.children}
                <Modal 
                    show={showReleaseModal} 
                    title={"Data Scope Limitation: Entities Pre-Date Collection"} 
                    showActionButtons={false} 
                    dialogClassName="entity-filter-modal" 
                    handleClose={()=>{this.setState({
                        earlyReleaseShown: true
                    })}}
                 >
                     <p>The entities listed below were released prior to the start date of your data collection. As a result, they fall outside the current report's scope and have been omitted.</p>
                     <ul>
                        {earlyReleaseEntries.map(entry=><li key={entry.id}>{entry.name} ({entry.code}) released on {entry.releaseDate}</li>)}
                     </ul>
                
                 </Modal>

            </React.Fragment> :
            <React.Fragment>
             <Spinner enabled={true} className="spinner spinner-inline" />
             <Modal 
                show={firstDaysWarning} 
                title={"Entity types unsupported"} 
                showActionButtons={false} 
                dialogClassName="entity-filter-modal" 
                handleClose={()=>{this.props.history.push('/main')}}
             >
                 <p>Please include tracks or products in your filter to access this feature</p>
             </Modal>
            </React.Fragment>
    }
}

function mapStateToProps(state) {
    return {
        stats: state.stats,
        milestones: state.milestones,
        filter: state.filter,
        user: state.user
    } 
}


function mapDispatchToProps(dispatch, ownProps) {
    return {
        getEntitiesMetadata: (filtered) => {
            //const { filtered = [] } = ownProps; 
            return dispatch(statsActions.getMultiEntitiesMetadata(filtered));
        },
        getEntitiesMilestones: (filtered) => {
            //const { filtered = [] } = ownProps;
            return dispatch(milestonesActions.getEntityMilestones('mixed', null, filtered, true));    
        },
        resetMinDate: () => {
            return dispatch(statsActions.resetMinDate());   
        }
        
    } 
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DataProvider));